'use strict';

const $ = require('jquery');
const Flickity = require('flickity/dist/flickity.pkgd.js');

const SELECTORS = {
    SCROLLER: '.js-scroller'
};

function init() {
    var scroller = $(SELECTORS.SCROLLER);

    if (!scroller.length) {
        return false;
    }

    setTimeout(function(){
        [].forEach.call(document.querySelectorAll('.js-scroller'), function (elem) {
            new Flickity( elem, {
                freeScroll: true,
                pageDots: false,
                watchCSS: true,
                freeScrollFriction: 0.03,
                wrapAround: true,
                groupCells: true,
            });
        });
    }, 1000);

    Flickity.prototype._createResizeClass = function() {
        this.element.classList.add('flickity-resize');
    };

    Flickity.prototype._getWrapShiftCells = function() {
        // only for wrap-around
        if ( !this.options.wrapAround ) {
            return;
        }

        // cancel wrap-around if content smaller than container
        var lastCell = this.getLastCell();
        var contentWidth = this.slideableWidth - lastCell.size[ this.options.rightToLeft ? 'marginLeft' : 'marginRight' ];
        if ( contentWidth <= this.size.innerWidth ) {
            this.options.wrapAround = false;
        } else {
            this.options.wrapAround = true;
        }

        // unshift previous cells
        this._unshiftCells( this.beforeShiftCells );
        this._unshiftCells( this.afterShiftCells );
        // get before cells
        // initial gap
        var gapX = this.cursorPosition;
        var cellIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
        // get after cells
        // ending gap between last cell and end of gallery viewport
        gapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
    };

    Flickity.createMethods.push('_createResizeClass');

    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
        this.element.classList.remove('flickity-resize');
        resize.call( this );
        this.element.classList.add('flickity-resize');
    };
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/scroller.js